import l from "./index.es474.js";
function s(r, n) {
  var t = typeof Symbol < "u" && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = u(r)) || n) {
    t && (r = t);
    var e = 0;
    return function() {
      return e >= r.length ? { done: !0 } : { done: !1, value: r[e++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function u(r, n) {
  if (r) {
    if (typeof r == "string") return o(r, n);
    var t = {}.toString.call(r).slice(8, -1);
    return t === "Object" && r.constructor && (t = r.constructor.name), t === "Map" || t === "Set" ? Array.from(r) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? o(r, n) : void 0;
  }
}
function o(r, n) {
  (n == null || n > r.length) && (n = r.length);
  for (var t = 0, e = Array(n); t < n; t++) e[t] = r[t];
  return e;
}
function c(r) {
  var n = '<?xml version="1.0"?>';
  n += '<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">';
  for (var t = s(r), e; !(e = t()).done; ) {
    var a = e.value, i = a.trim().length === a.length ? "" : ' xml:space="preserve"';
    n += "<si><t".concat(i, ">"), n += l(a), n += "</t></si>";
  }
  return n += "</sst>", n;
}
export {
  c as default
};
//# sourceMappingURL=index.es432.js.map
